export default function FormControlLabel() {
  return {
    MuiFormControlLabel: {
      styleOverrides: {
        labelPlacementStart: {
          marginLeft: 0,
        },
      },
    },
  };
}
